// @ts-ignore
import App from "./components/App.svelte"
import { location } from "./store"
import { commitTime, release } from "../../api/hooks/config-client"
import "./i18n"

let _apiBaseURL = typeof window !== "undefined" && window.localStorage?.getItem("apiBase")
const apiBaseURL = _apiBaseURL || "/api/"
console.log("Release: ", release, commitTime)
console.log("API Base: ", apiBaseURL)
const publishLocation = (_p?: string) => {
    let _s: string
    let _h: string
    if (_p) {
        if (typeof _p !== "string") {
            console.warn("_p is not a string:", _p)
            return
        }

        const parts = _p.split("#")
        _p = parts.shift() as string
        _h = parts.join()
        if (_h) _h = "#" + _h

        const parts2 = _p.split("?")
        _p = parts2.shift()
        _s = parts2.join()
        if (_s) _s = "?" + _s
    }

    const newLocation = {
        path: _p || (typeof window !== "undefined" && window.location?.pathname),
        search: _p ? _s : typeof window !== "undefined" && window.location?.search,
        hash: _p ? _h : typeof window !== "undefined" && window.location?.hash,
        push: !!_p,
        pop: !_p,
        categoryPath: "",
    }
    newLocation.categoryPath = newLocation.path.replace(/\/\d{4,99}[^\/]+$/, "")
    location.set(newLocation)
}

if (typeof history !== "undefined") {
    // History-API-Patching für Location-Tracking (moderne Browser, Proxy)
    const historyApply = (
        target: typeof history.pushState,
        thisArg: unknown,
        argumentsList: Parameters<typeof history.pushState>
    ) => {
        const url = argumentsList && argumentsList.length >= 2 && argumentsList[2]
        publishLocation(typeof url === "string" ? url : url ? String(url) : undefined)
        Reflect.apply(target, thisArg, argumentsList)
    }

    history.pushState = new Proxy(history.pushState, {
        apply: historyApply,
    })

    history.replaceState = new Proxy(history.replaceState, {
        apply: historyApply,
    })
} // else ssr -> no history handling
typeof window !== "undefined" &&
    window.addEventListener("popstate", (event) => {
        publishLocation()
    })

let appContainer = document?.getElementById("appContainer")

const hydrate = true //import.meta?.env?.MODE !== "development"
console.log("Features: ", { hydrate })

let app
if (appContainer) {
    app = new App({
        target: appContainer,
        props: {},
        hydrate,
    })
} else {
    console.error("No appContainer found")
}

export default app

// PWA
if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
    console.log("Registering service worker")
    navigator.serviceWorker
        .register("/serviceworker.js", { scope: "/" })
        .then((reg) => {
            console.log("Registration succeeded. Scope is " + reg.scope)
        })
        .catch((e) => {
            console.log("Registration failed:", e)
        })
}
